import React from 'react';
import { MemoryRouter as Router, Routes, Route } from 'react-router-dom';
import { Header } from './components/Header';
import { Clock } from './components/Clock';
import { Sidebar, SidebarProvider } from './components/Sidebar';
import { CurrentTopic } from './components/CurrentTopic';
import { WeeklyStats } from './components/WeeklyStats';
import { TodaySchedule } from './components/TodaySchedule';
import { Schedule } from './pages/Schedule';
import { TopicProgress } from './pages/TopicProgress';
import { QuestionArchive } from './pages/QuestionArchive';
import { Topics } from './pages/Topics';
import { Questions } from './pages/Questions';
import { Guidance } from './pages/Guidance';
import { Analysis } from './pages/Analysis';
import { Forum } from './pages/Forum';
import { LessonViewer } from './pages/LessonViewer';
import { Profile } from './pages/Profile';
import { Messages } from './pages/Messages';
import { Homework } from './pages/Homework';
import { SubscriptionInfo } from './pages/SubscriptionInfo';
import { NotificationsHistory } from './pages/NotificationsHistory';
import { OnlineExams } from './pages/OnlineExams';
import { ExamInterface } from './pages/ExamInterface';
import { ExamBreak } from './pages/ExamBreak';
import { ExamResults } from './pages/ExamResults';
import { ProgramProvider } from './contexts/ProgramContext';
import { MessagesProvider } from './contexts/MessagesContext';
import { useToast } from './components/Toast';
import './styles/globals.css';
import { VideoSolutionsLibrary } from './pages/VideoSolutionsLibrary';
export function App() {
  const {
    ToastContainer
  } = useToast();
  return <ProgramProvider data-id="element-0">
      <MessagesProvider data-id="element-1">
        <SidebarProvider data-id="element-2">
          <Router data-id="element-3">
            <div className="min-h-screen w-full bg-[#080808] text-white" data-id="element-4">
              <div className="max-w-7xl mx-auto px-4 sm:px-6 lg:px-8 py-4 sm:py-6" data-id="element-5">
                <div className="flex flex-col space-y-6" data-id="element-6">
                  <div className="flex flex-col items-center space-y-4" data-id="element-7">
                    <div className="w-full flex flex-col sm:flex-row sm:items-center sm:justify-between space-y-4 sm:space-y-0" data-id="element-8">
                      <h1 className="text-2xl font-bold text-center sm:text-left" data-id="element-9">
                        Hoş geldin,{' '}
                        <span className="text-purple-400" data-id="element-10">Ahmet</span>
                      </h1>
                      <div className="flex justify-center sm:justify-end" data-id="element-11">
                        <Header data-id="element-12" />
                      </div>
                    </div>
                    <Clock data-id="element-13" />
                  </div>
                  <div className="flex flex-col md:flex-row gap-6" data-id="element-14">
                    <Sidebar data-id="element-15" />
                    <main className="flex-1 min-w-0" data-id="element-16">
                      <Routes data-id="element-17">
                        <Route path="/" element={<div className="space-y-6" data-id="element-19">
                              <CurrentTopic data-id="element-20" />
                              <WeeklyStats data-id="element-21" />
                              <TodaySchedule data-id="element-22" />
                            </div>} data-id="element-18" />
                        <Route path="/topics" element={<Topics data-id="element-24" />} data-id="element-23" />
                        <Route path="/questions" element={<Questions data-id="element-26" />} data-id="element-25" />
                        <Route path="/archive" element={<QuestionArchive data-id="element-28" />} data-id="element-27" />
                        <Route path="/guidance" element={<Guidance data-id="element-30" />} data-id="element-29" />
                        <Route path="/analysis" element={<Analysis data-id="element-32" />} data-id="element-31" />
                        <Route path="/schedule" element={<Schedule data-id="element-34" />} data-id="element-33" />
                        <Route path="/progress" element={<TopicProgress data-id="element-36" />} data-id="element-35" />
                        <Route path="/forum" element={<Forum data-id="element-38" />} data-id="element-37" />
                        <Route path="/forum/konu/:questionId" element={<Forum data-id="element-40" />} data-id="element-39" />
                        <Route path="/messages" element={<Messages data-id="element-42" />} data-id="element-41" />
                        <Route path="/homework" element={<Homework data-id="element-44" />} data-id="element-43" />
                        <Route path="/online-denemeler" element={<OnlineExams data-id="element-46" />} data-id="element-45" />
                        <Route path="/online-denemeler/:id/coz" element={<ExamInterface data-id="element-48" />} data-id="element-47" />
                        <Route path="/online-denemeler/:id/mola" element={<ExamBreak data-id="element-50" />} data-id="element-49" />
                        <Route path="/online-denemeler/:id/sonuc" element={<ExamResults data-id="element-52" />} data-id="element-51" />
                        <Route path="/topics/:subject/:unit" element={<LessonViewer data-id="element-54" />} data-id="element-53" />
                        <Route path="/video-solutions/:subject" element={<VideoSolutionsLibrary data-id="element-56" />} data-id="element-55" />
                        <Route path="/profile" element={<Profile data-id="element-58" />} data-id="element-57" />
                        <Route path="/subscription" element={<SubscriptionInfo data-id="element-60" />} data-id="element-59" />
                        <Route path="/bildirimler" element={<NotificationsHistory data-id="element-62" />} data-id="element-61" />
                      </Routes>
                    </main>
                  </div>
                </div>
              </div>
              {/* Global Toast Container */}
              <ToastContainer data-id="element-63" />
            </div>
          </Router>
        </SidebarProvider>
      </MessagesProvider>
    </ProgramProvider>;
}